import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import App from "./components/App";
import store from "./storeDispatcher/store";


ReactDOM.render(
    <Provider store={store}>
        <Router>
            <Switch>

                <Route
                    path='/:objectId'
                    exact
                    component={App}
                />
                <Route
                    path='/'
                    exact
                    component={App}
                />
            </Switch>
        </Router>
    </Provider>
    , document.getElementById('root'));


